import styled from '@emotion/styled';
import { Divider } from '@mui/material';

export const StyledItemDivider = styled(Divider)`
  margin-left: 16px;
`;
